import { render, staticRenderFns } from "./right.vue?vue&type=template&id=5d426ffa&scoped=true&"
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=5d426ffa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d426ffa",
  null
  
)

export default component.exports